import tenantApi from '../../../../api/clients/tenant';
import { OrganizationDetails } from '../types/interfaces/organization-details';

export const fetchOrganizationDetails =
  async (): Promise<OrganizationDetails> => {
    const { data } = await tenantApi.get<OrganizationDetails>('/details');

    return data;
  };
